import {
  Box,
  Switch,
  FormControlLabel,
  Paper,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useState } from 'react';
import usePartner from '../../../lib/hooks/usePartner';

export default function PartnerSwitcher() {
  const { partnerKey, setPartnerKey, removePartnerKey, isPartnerMode } =
    usePartner();

  const AVAILABLE_PARTNERS = ['pax', 'economico'];
  const [selectedPartner, setSelectedPartner] = useState<string>(
    partnerKey || 'pax'
  );

  const handlePartnerToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    if (checked) {
      setPartnerKey(selectedPartner);
      setTimeout(() => window.location.reload(), 100);
    } else {
      removePartnerKey();
      setTimeout(() => window.location.reload(), 100);
    }
  };

  const handlePartnerChange = (event: any) => {
    const newPartner = event.target.value;
    setSelectedPartner(newPartner);

    if (isPartnerMode) {
      setPartnerKey(newPartner);
      setTimeout(() => window.location.reload(), 100);
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 70,
        zIndex: 1300, // Lower than default MUI Select dropdown (1300+)
        padding: 2,
        opacity: 0.9,
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minWidth: 200,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Testing Tool
      </Typography>

      <FormControl size="small" fullWidth>
        <InputLabel>Partner</InputLabel>
        <Select
          value={selectedPartner}
          onChange={handlePartnerChange}
          label="Partner"
        >
          {AVAILABLE_PARTNERS.map((partner) => (
            <MenuItem key={partner} value={partner}>
              {partner.charAt(0).toUpperCase() + partner.slice(1)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Switch
            checked={isPartnerMode}
            onChange={handlePartnerToggle}
            color="primary"
          />
        }
        label={
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2">
              {isPartnerMode ? 'Partner Mode' : 'Default Mode'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {isPartnerMode ? `Partner: ${partnerKey}` : 'No partner'}
            </Typography>
          </Box>
        }
      />
    </Paper>
  );
}
